import React from "react";
import LogoIcons from "../Helpers/Logos";

function Footer() {
  return (
    <footer class="relative">
      <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <LogoIcons />
      </div>
    </footer>
  );
}
export default Footer;
